import Vue from 'vue'
import axios from 'axios'

const initState = {
  activeProducts: [],
  activeProductsObject: {},
  currency: '$'
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    SET_ACTIVEPRODUCTS(state, activeProducts) {
      state.activeProducts = activeProducts
      const object = {}
      activeProducts.forEach((product) => {
        object[`product-${product.id}`] = product
      })
      state.activeProductsObject = object
    },
    UPDATE_ACTIVEPRODUCT(state, singleProduct) {
      const activeProducts = state.activeProducts
      const activeProductsObject = state.activeProductsObject
      if (!activeProductsObject[`product-${singleProduct.id}`]) {
        activeProducts.push(singleProduct)
      } else {
        let indexFound = -1
        activeProducts.every((item, index) => {
          if (item.id === singleProduct.id) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          activeProducts.splice(indexFound, 1, singleProduct)
        }
      }
      activeProductsObject[`product-${singleProduct.id}`] = singleProduct
      state.activeProducts = activeProducts
      state.activeProductsObject = activeProductsObject
    },
    DELETE_ACTIVEPRODUCT(state, singleProductId) {
      const activeProducts = state.activeProducts
      const activeProductsObject = state.activeProductsObject
      if (activeProductsObject[`product-${singleProductId}`]) {
        delete activeProductsObject[`product-${singleProductId}`]
        let indexFound = -1
        activeProducts.every((item, index) => {
          if (item.id === singleProductId) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          activeProducts.splice(indexFound, 1)
        }
      }
      state.activeProducts = activeProducts
      state.activeProductsObject = activeProductsObject
    },
    SET_ACTIVECURRENCY(state, currency) {
      state.currency = currency;
    }
  },
  actions: {
    getInvoices({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/invoices`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getSubscriptions({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/subscriptions`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    cancelSubscription({ commit }, { landingId, accountId, lsSubscriptionId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/stripe-connected/${accountId}/subscriptions/${lsSubscriptionId}/cancel`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getActiveProducts({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/active-products`)
          .then((res) => {
            commit('SET_ACTIVEPRODUCTS', res.data.products)
            resolve(res.data.products)
          })
          .catch((error) => reject(error))
      })
    },
    getProducts({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/products`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getCoupons({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/coupons`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createCoupon({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/coupons`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    archiveCoupon({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/coupons/${params.id}/archive`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    unarchiveCoupon({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/coupons/${params.id}/unarchive`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    destroyCoupon({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/coupons/${params.id}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/products`, params)
          .then((res) => {
            commit('UPDATE_ACTIVEPRODUCT', res.data.product)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    updateProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/products/${params.id}`, params)
          .then((res) => {
            commit('UPDATE_ACTIVEPRODUCT', res.data.product)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    archiveProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/products/${params.id}/archive`)
          .then(() => {
            commit('DELETE_ACTIVEPRODUCT', params.id)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    unarchiveProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/products/${params.id}/unarchive`)
          .then(() => {
            commit('DELETE_ACTIVEPRODUCT', params.id)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    destroyProduct({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landing_id}/stripe-connected/${params.account_id}/products/${params.id}`)
          .then(() => {
            commit('DELETE_ACTIVEPRODUCT', params.id)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
  },
  getters: {
    activeProducts(state) { return state.activeProducts },
    activeProductsObject(state) { return state.activeProductsObject }
  }
}